"use client"

import { Button } from "@/components/ui/button"
import { X } from "lucide-react"
import type { Review } from "@/types/review"
import { ReviewDetail } from "./review-detail"
import { useTranslations } from "@/hooks/use-translations"

interface ReviewDrawerProps {
  review: Review | null
  onClose: () => void
  onMarkHelpful: (reviewId: string) => void
}

export function ReviewDrawer({ review, onClose, onMarkHelpful }: ReviewDrawerProps) {
  const { t } = useTranslations()

  if (!review) return null

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[110]" onClick={onClose} />

      {/* Side Drawer */}
      <div className="fixed right-0 top-0 h-full w-full max-w-2xl bg-white shadow-xl z-[110] transform transition-transform duration-300 ease-in-out overflow-y-auto">
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between z-10">
          <h2 className="text-lg font-semibold">{t("userExperience")}</h2>
          <Button variant="outline" size="icon" onClick={onClose} className="bg-transparent">
            <X className="w-4 h-4" />
          </Button>
        </div>

        <div className="p-6">
          <ReviewDetail review={review} onMarkHelpful={onMarkHelpful} />
        </div>
      </div>
    </>
  )
}
